(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-discount-modal"] && !Shopify.designMode) return;
  try {
    // Attach lightweight copy handler to the dialog component instance
  (() => {
    const root = document.getElementById('email-discount-modal');
    if (!root) return;
    // Provide a method the on:click directive can call
    root.copyCode = (event) => {
      const btn = /** @type {HTMLElement} */ (event?.target);
      const value = btn?.getAttribute('data-copy') || '';
      if (!value) return;
      navigator.clipboard?.writeText(value).then(() => {
        btn.classList.add('is-copied');
        setTimeout(() => btn.classList.remove('is-copied'), 1500);
      });
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
